import { createElement } from 'react'

import { getIconCatalog } from './catalog'

type LucideIconByNameProps = {
  name: string
  color?: string
  size?: number
}

export const LucideIconByName = ({
  name,
  color,
  size
}: LucideIconByNameProps) => {
  const Icon = getIconCatalog().byName.get(name)

  if (!Icon) return null

  return createElement(Icon, { color, size })
}
